<template>
    <ul class="nav">
        <li>
            <router-link class="sidebar-link color-purple" to="/" exact>
                <i class="fal fa-tachometer-alt-average" />
                <span class="sidebar-link-text">Dashboard</span>
            </router-link>
        </li>
        <li>
            <router-link class="sidebar-link color-blue" to="/tools">
                <i class="fal fa-tools" />
                <span class="sidebar-link-text">Tools</span>
            </router-link>
        </li>
        <li class="soon">
            <span class="soon-message">Coming soon:</span>
        </li>
        <li>
            <router-link class="sidebar-link color-green disabled" to="/analytics">
                <i class="fal fa-chart-bar" />
                    <span class="sidebar-link-text">Analytics</span>
            </router-link>
        </li>
        <li>
            <router-link class="sidebar-link color-red disabled" to="/integrations">
                <i class="fal fa-plug" />
                    <span class="sidebar-link-text">Integrations</span>
            </router-link>
        </li>
        <li>
            <router-link class="sidebar-link color-pink mobile-hidden disabled" to="/library" :disabled="!user.pro">
                <i class="fal fa-books" />
                    <span class="sidebar-link-text">Library</span>
                    <base-label v-show="!user.pro">
                        Pro
                    </base-label>
            </router-link>
        </li>
        <li>
            <router-link class="sidebar-link color-light-purple mobile-hidden disabled" to="/community" :disabled="!user.pro">
                <i class="fal fa-users" />
                    <span class="sidebar-link-text">Community</span>
                    <base-label v-show="!user.pro">
                        Pro
                    </base-label>
            </router-link>
        </li>
    </ul>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: mapState([
        'user',
    ]),
};
</script>
